import React, { useState, useEffect, useRef } from "react";
import OcrLayout from "./components/OcrLayout.jsx";
import NavPage from "./components/Nav.jsx";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect
} from "react-router-dom";
import navItemsTest from './const/menu.json' ;
import { getProductList} from './utils/api';
import { getQueryString,checkIsInWhite } from './utils/index';

function Home(props) {
  const [action, setAction] = useState(""); //  当前选中菜单
  const [navItems, setNavItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentMune, setCurrentMune] = useState(null);

  // 使用 useRef 来保存最新的状态值
  const actionRef = useRef(action);
  const navItemsRef = useRef(navItems);
  const currentMuneRef = useRef(currentMune);
  const ocrLayoutRef = useRef(); // 新增：OcrLayout 组件的 ref

  // 更新 ref 的值
  useEffect(() => {
    actionRef.current = action;
  }, [action]);

  useEffect(() => {
    navItemsRef.current = navItems;
  }, [navItems]);

  useEffect(() => {
    currentMuneRef.current = currentMune;
  }, [currentMune]);

useEffect(() => {
    async function func() {
      setLoading(true)
      const action = getQueryString('action');
      setAction(action);
      const res = await getProductList()
      setLoading(false);
      if (res?.config?.defaultConfig) {
        let _navItems = res.config.defaultConfig;
        // let _navItems = navItemsTest.defaultConfig;
        let _whiteList = [];
        _navItems.flat().map(i => {
          i.children.map(c => {
            if (c.whiteList?.length > 0) {
              _whiteList = _whiteList.concat(c.whiteList)
            }
          })
        });
        const whiteListRule = _whiteList.length <= 0 ? {} : await checkIsInWhite(_whiteList);

        _navItems = _navItems.flat().map(i => {
          return {
            ...i,
            children: i.children.filter(c => {
              // 配置了直接不显示
              if (typeof (c.IsHide) === 'boolean') {
                return !c.IsHide
                // 配置通过白名单显示
              } else if (typeof (c.IsHide) === 'object') {
                return whiteListRule[c.IsHide]?.length > 0
              } else {
                return true
              }
            }).map(child =>{
              return{
                ...child,
                menuKey:i.key
              }
            })
          }
        });
        setNavItems(_navItems);
        delCurrentMune(action,_navItems);
      }
    }
    func();

  }, [])

  // 监听路由search中action参数的变化
  useEffect(() => {
    const handleRouteChange = () => {
      const currentAction = getQueryString('action');
      console.log('currentAction',currentAction,'action',actionRef.current,'navItems',navItemsRef.current)
      if (currentAction) {
        delCurrentMune(currentAction, navItemsRef.current);
      }
    };

    // 监听popstate事件（浏览器前进后退）
    window.addEventListener('popstate', handleRouteChange);
    

    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);

  const  delCurrentMune = (action,navItems = navItems) => {
        const list = navItems?.map(i => i.children).flat();
        const result = list?.find(i => {
          return i.action === action;
        });
        console.log('delCurrentMune',action,'result',result)
        if(result){
          setAction(result.action);
          setCurrentMune(result);
          // 新增：调用 OcrLayout 组件的 setMenuConfig 方法
          if (ocrLayoutRef.current) {
            ocrLayoutRef.current.setMenuConfig(result);
          }
        }
  }

  return (<>
    <Router>
      <Switch>
        <Route path="/">
        {
          loading ? <></> : <>
          {action ? <OcrLayout 
          ref={ocrLayoutRef} // 新增：传递 ref 给 OcrLayout 组件
          menuList={navItems}
          action={action}
          currentMune={currentMune}
          defaultNavItems={navItems}
          onChangeAction={(action) => {
            delCurrentMune(action,navItems)
            window.location.search = `action=${action}`
          }}
          /> : <NavPage 
          navList={navItems} 
          onChangeAction={(action) => {
            // setAction(action)
            // delCurrentMune(action,navItems)
            window.location.search = `action=${action}`
            // TODO currentMune处理
          }}/>}
          </>
        }
          
        </Route>
        <Route path="*">
          <Redirect to="/" />
        </Route>
      </Switch>
    </Router>
  </>

  );
}

export default Home;